<template lang="pug">
div.text
  el-collapse(value="0")
    el-collapse-item(
      :title="title",
      :name="collapsed"
    )
      .body
        slot
</template>
<script>
export default {

  props: {
    title: {
      type: String,
      required: true
    },

    collapsed: {
      type: String,
      default: '0'
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.body {
  padding: 10px;
}
/deep/ .el-collapse-item__header {
  font-size: 14px;
  color: $font-dark-color;
  font-weight: bold;
}

.text-collapse.text >>> .el-collapse-item__header{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppCollapseChild.vue